export default "__VITE_ASSET__9dfb2691__"